module.exports = __webpack_public_path__ + "img/logo_letras_blancas.51fd1243.svg";